import buildPBComponents from './buildPBComponents';

export default buildPBComponents;
